<template>
  <header class="header">
    <div class="container">
      <div class="logo">
        <router-link :to="'/home'"
          ><img src="/logo.svg" alt="Azadi Academy Logo"
        /></router-link>
        <!-- <div class="logo-text">
          <h2>Azadi</h2>
          <span class="text-center">Coin</span>
        </div> -->
      </div>
      <nav class="nav" :class="{ 'mobile-nav': isMobileNavVisible }">
        <ul>
          <li @click="isMobileNavVisible = false">
            <router-link :to="'/home'">Home</router-link>
          </li>
          <li @click="isMobileNavVisible = false">
            <router-link :to="'/category'">Tutorials</router-link>
          </li>
          <li @click="isMobileNavVisible = false">
            <router-link :to="'/live-training'">Live Training</router-link>
          </li>
          <li @click="isMobileNavVisible = false">
            <a href="#contact">Contact</a>
          </li>
          <li
            @click="isMobileNavVisible = false"
            class="other"
            v-if="!isLoggedIn"
          >
            <router-link :to="'/login'">Login</router-link>
          </li>
          <li
            @click="isMobileNavVisible = false"
            class="auth-buttons other"
            v-if="!isLoggedIn"
          >
            <router-link :to="'/register'"
              ><button class="signup-btn">Create Account</button></router-link
            >
          </li>
        </ul>
      </nav>
      <div class="auth-buttons-container">
        <div class="auth-buttons desktop-btn" v-if="!isLoggedIn">
          <router-link :to="'/login'"
            ><button class="login-btn">Login</button></router-link
          >
          <router-link :to="'/register'"
            ><button class="signup-btn">Create Account</button></router-link
          >
        </div>
        <div class="auth-buttons" v-else>
          <button class="login-btn" @click="show = !show">My Account</button>
          <div class="list-action" v-if="show" @click="show = false">
            <router-link :to="'/my-profile'"><div>My Profile</div></router-link>
            <router-link :to="'/my-courses'"
              ><div>My Tutorials</div></router-link
            >
            <router-link :to="'/live-courses'"
              ><div>Live Courses</div></router-link
            >
            <router-link :to="'/my-requests'"
              ><div>My Requests</div></router-link
            >
            <div @click="logout">Logout</div>
          </div>
        </div>
        <!-- Mobile Menu Toggle -->
        <button class="mobile-menu-btn" @click="toggleMobileNav">
          <img src="/menu-icon.svg" alt="Menu Icon" />
        </button>
      </div>
    </div>
  </header>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";
export default {
  name: "Header",
  data() {
    return {
      show: false,
      isMobileNavVisible: false
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isAuthenticated;
    },
  },
  mounted() {
    this.getIP();
  },
  methods: {
    ...mapActions(["LogOut"]),
    toggleMobileNav() {
      this.isMobileNavVisible = !this.isMobileNavVisible;
    },
    async getIP() {
      try {
        const ipRes = await fetch("https://api.ipify.org?format=json");
        const ipData = await ipRes.json();
        const ip = ipData.ip;

        const locationRes = await fetch(`https://ipapi.co/${ip}/json/`);
        const location = await locationRes.json();

        const data = {
          ip_address: location.ip,
          city: location.city,
          country: location.country_name,
          lat: location.latitude,
          long: location.longitude,
        };

        await axios.post("visitor/add", data);

      } catch (err) {
        console.error("Error getting IP/location:", err);
      }
    },
    async logout() {
      try {
        await this.LogOut(this.form);
        this.$router.push("/login");
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.header {
  /* background-color: #00103e; */
  background-color: #121e4a;
  color: white;
  padding: 1rem 0;
}
.logo-text {
  font-family: Bebas;
  letter-spacing: 0.1rem;
  display: flex;
  flex-direction: column;
}
.logo-text h2 {
  font-size: 2rem;
}
.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2rem;
  position: relative;
}
.logo {
  display: flex;
  gap: 0.2rem;
  align-items: center;
}
.logo img {
  width: 100%;
  height: 6rem;
  margin-right: 10px;
}
.nav ul {
  list-style: none;
  display: flex;
  gap: 2rem;
}
.nav a {
  font-size: 1.8rem;
  color: white;
  text-decoration: none;
  font-family: Bebas;
}
.other {
  display: none;
}
.text-center {
  text-align: center;
}
.auth-buttons {
  position: relative;
}
.auth-buttons .list-action {
  position: absolute;
  border: 1px solid #ccc;
  background-color: #fff;
  margin-left: 1rem;
  z-index: 9999;
  font-family: "Gothic";
}
.auth-buttons .list-action div {
  padding: 0.6rem 1rem;
  width: 9rem;
  color: #000;
  font-size: 1.1rem;
}
.auth-buttons .list-action div:hover {
  cursor: pointer;
  color: #f0c57a;
  text-decoration: underline;
}
.auth-buttons .login-btn {
  color: #f0c57a;
  border: none;
  padding: 0.5rem 1rem;
  margin-right: 10px;
  background-color: transparent;
  cursor: pointer;
  font-size: 1.2rem;
}
.auth-buttons .login-btn:hover {
  text-decoration: underline;
}
.auth-buttons .signup-btn {
  padding: 0.6rem 2rem;
  background-color: #f0c57a;
  color: #000;
  border: 1px solid #f0ba7c;
  outline: none;
  border-radius: 0.5rem;
  font-weight: 700;
  font-size: 1rem;
  padding: 0.6rem 2rem;
  font-family: "Gothic";
}

/* Mobile Menu Button */
.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
}

.mobile-menu-btn img {
  width: 2rem;
}

.mobile-nav {
  display: none;
}

/* Media Queries for Responsiveness */
@media (max-width: 950px) {
  .container {
    padding: 0 1rem;
  }

  .nav {
    position: absolute;
    top: 100%;
    right: 0;
    background-color: #00103e;
    width: 100%;
    /* height: 200px; */
    display: none;
    flex-direction: column;
    align-items: flex-start;
    padding: 2rem;
    z-index: 9;
  }

  .nav.mobile-nav {
    display: flex;
  }

  .nav ul {
    flex-direction: column;
    gap: 1rem;
  }

  .nav a {
    font-size: 1.5rem;
  }

  .auth-buttons-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .mobile-menu-btn {
    display: block;
  }

  /* .auth-buttons {
    display: none;
  } */

  .nav.mobile-nav + .auth-buttons {
    display: block;
    margin-top: 2rem;
  }
}

@media (max-width: 600px) {
  .other {
    display: block;
  }
  .desktop-btn {
    display: none;
  }
}

@media (max-width: 480px) {
  .logo-text h2 {
    font-size: 1.5rem;
  }

  .logo img {
    height: 8rem;
  }

  .mobile-menu-btn img {
    width: 1.5rem;
  }
}
</style>
